//
//
//
//
//
//

export default {
  name: 'WarningMessage'
}
